import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FUND_LIST, FUND_ADDEDIT, FUND_WOP_LIST, FUND_CHANGE_STATUS, FUND_DELETE } from "../../api/constApi";
import { fundListApi, fundChangeStatusApi, fundWopListApi, AddEditFundApi, fundDeleteApi } from "../Services/fundsService";
import { useSelector } from "react-redux";
import { useMemo } from "react";

export const fundsList = createAsyncThunk(FUND_LIST, async (payload) => {
    const response = await fundListApi(payload);
    return response.data;
});

export const fundsChangeStatus = createAsyncThunk(FUND_CHANGE_STATUS, async (payload) => {
    const response = await fundChangeStatusApi(payload);
    return response.data;
});

export const addEditFunds = createAsyncThunk(FUND_ADDEDIT, async (payload) => {
    const response = await AddEditFundApi(payload);
    return response.data;
});

export const fundsWopList = createAsyncThunk(FUND_WOP_LIST, async (payload) => {
    const response = await fundWopListApi(payload);
    return response.data;
});

export const fundsDelete = createAsyncThunk(FUND_DELETE, async (payload) => {
    const response = await fundDeleteApi(payload);
    return response.data;
});

export const fundsSlice = createSlice({
    name: "funds",
    initialState: {
        funds: null,
        // districtWop: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fundsList.fulfilled, (state, action) => {
            state.funds = action?.payload;
        });
        builder.addCase(addEditFunds.fulfilled, (state, action) => {
            state.funds = action?.payload?.Data;
        });
    }
});

export default fundsSlice.reducer;